import React, { ReactNode } from 'react'
import { useAuthStore } from '../stores/authStore'
import Header from './Header'
import { useIdleTimeout } from '../hooks/useIdleTimeout'

interface LayoutProps {
  children: ReactNode
}

export default function Layout({ children }: LayoutProps) {
  const { user, logout } = useAuthStore()
  useIdleTimeout()

  return (
    <div className="flex h-screen bg-gray-50">
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header user={user} onLogout={logout} />
        <main className="flex-1 overflow-auto">
          {children}
        </main>
      </div>
    </div>
  )
}
